import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
// import axiosInstance from "../../../../../services/api/API";
// import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import Swal from "sweetalert2";
import downloadIcon from "../../../../../Assets/icons/download.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt, FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";
import { showAlert } from "../../../../customComponents/CustomSweetAlert/ShowAlert";

const DetailsTable = ({
  isSubmit,
  headers,
  data = [],
  keyMapping,
  currentPage,
  handleViewButton = () => {},
  handleClicableRow = () => {},
  handleEditClick,
  POID,
  handleSave,
  editRowId,
  editedQuantity,
  allotData,
  updateIcon,
  mailIcon,
  toggleSerialDrawer = () => {},
  fetchActionTaken = () => {},
  handleOrderClaimIcon = () => {},
  isExport,
  isOrderPending,
  isModified,
  reSubmitted,
  isOrderApproved,
  isOrderPartiallyApproved,
  isHold,
  handleMailFunc,
  totalRecords,

  itemsPerPage,
  totalPages,
  onPageChange,
  pdfDownLoad,
}) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [quantities, setQuantities] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHoldModalOpen, setIsHoldModalOpen] = useState(false);
  const [remark, setRemark] = useState("");
  const [expectedDate, setExpectedDate] = useState("");
  const [formattedDate, setFormattedDate] = useState("");

  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  const [acceptModal, setAcceptModal] = useState(false);

  const [exportModal, setExportModal] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);

  const [errorVal, setErrorVal] = useState(0);
  const [successVal, setSuccessVal] = useState(0);

  // States for downloading failed records
  const [failedRows, setFailedRows] = useState([]);
  const [uploadedHeaders, setUploadedHeaders] = useState([]);

  const datePickerRefs = useRef({}); // Reference for DatePicker

  const handleChange = (fieldName, date) => {
    // Format the date to "dd/MM/yyyy" and update state
    const formattedDate = date
      ? date.toLocaleDateString("en-GB").replace(/\//g, "/")
      : "";
    setExpectedDate(formattedDate);
  };

  const openDatePicker = (fieldName) => {
    // Open DatePicker when icon is clicked
    if (datePickerRefs.current[fieldName]) {
      datePickerRefs.current[fieldName].setFocus();
    }
  };

  const token = localStorage.getItem("authToken");
  const loginUserId = localStorage.getItem("UserId");
  const sanitizedData = Array.isArray(data) ? data : [];
  const navigate = useNavigate();
  console.log("datadetails", allotData);

  console.log(data, "sanitizedData");

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(data.map((row) => row.po_id));
    }
    setSelectAll(!selectAll);
  };

  console.log(selectedRows, "selectedRows");

  const handleRowSelect = (rowId) => {
    console.log("clicked", rowId);
    let updatedSelectedRows;
    if (selectedRows.includes(rowId)) {
      updatedSelectedRows = selectedRows.filter((id) => id !== rowId);
    } else {
      updatedSelectedRows = [...selectedRows, rowId];
    }

    setSelectedRows(updatedSelectedRows);
    if (updatedSelectedRows.length === data.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };

  const handleQuantityChange = (e, rowId) => {
    setQuantities({ ...quantities, [rowId]: e.target.value });
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageClick = (pageIndex) => {
    onPageChange(pageIndex);
  };
  const visiblePages = 5; // Number of visible page buttons
  const startPage = Math.max(0, currentPage - Math.floor(visiblePages / 2));

  const endPage = Math.min(totalPages - 1, startPage + visiblePages - 1);

  const getStartIndex = () => {
    return currentPage * itemsPerPage + 1;
  };

  const getEndIndex = () => {
    return Math.min((currentPage + 1) * itemsPerPage, totalRecords);
  };

  const handleApprovedCancel = async () => {
    console.log("clicked");
    try {
      const formattedExpectedDate = expectedDate
        ? expectedDate.split("/").reverse().join("-")
        : null;

      const payload = {
        po_id: selectedRows.join(","),
        // date:formattedExpectedDate
      };

      const response = await axiosInstance.post("/cancle-bulk-po", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });

      if (response.status === 200) {
        Swal.fire({
          title: "Success",
          text: "Cancelled Successfully",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          // navigate("/manage-sales/manage-order")
          fetchActionTaken();
        });
      }

      // Create a URL for the file blob
      //  const url = window.URL.createObjectURL(new Blob([response.data]));

      //  // Create a link element
      //  const link = document.createElement('a');
      //  link.href = url;

      //  // Set the file name for the download to .csv
      //  link.setAttribute('download', 'sample.csv'); // Changed to .csv

      //  // Append the link to the body (required for some browsers)
      //  document.body.appendChild(link);

      //  // Programmatically trigger the click event on the link
      //  link.click();

      //  // Clean up the link after download
      //  document.body.removeChild(link);

      console.log(response, "response");
      // fetchActionTaken()
    } catch (error) {
      // console.error("Error submitting order:", error);
      console.error("Error adding warranty:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Please add po expected date in item! Check on details page";
      await Swal.fire({
        title: "Message",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleExportToExcel = async () => {
    console.log("clicked");
    try {
      const formattedExpectedDate = expectedDate
        ? expectedDate.split("/").reverse().join("-")
        : null;

      const payload = {
        po_id: selectedRows.join(","),
        // date:formattedExpectedDate
      };

      const response = await axiosInstance.post(
        "/approved-excel-bulk-download",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );

      // Create a URL for the file blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link element
      const link = document.createElement("a");
      link.href = url;

      // Set the file name for the download to .csv
      link.setAttribute("download", "sample.csv"); // Changed to .csv

      // Append the link to the body (required for some browsers)
      document.body.appendChild(link);

      // Programmatically trigger the click event on the link
      link.click();

      // Clean up the link after download
      document.body.removeChild(link);

      console.log(response, "response");
      // fetchActionTaken()
    } catch (error) {
      // console.error("Error submitting order:", error);
      console.error("Error adding warranty:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Please add po expected date in item! Check on details page";
      await Swal.fire({
        title: "Message",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleExport = async () => {
    console.log("clicked");
    try {
      const formattedExpectedDate = expectedDate
        ? expectedDate.split("/").reverse().join("-")
        : null;

      const payload = {
        po_id: selectedRows.join(","),
        date: formattedExpectedDate,
      };

      const response = await axiosInstance.post(
        "/download-sample-purchaseOrder",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );

      // Create a URL for the file blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link element
      const link = document.createElement("a");
      link.href = url;

      // Set the file name for the download to .csv
      link.setAttribute("download", "sample.csv"); // Changed to .csv

      // Append the link to the body (required for some browsers)
      document.body.appendChild(link);

      // Programmatically trigger the click event on the link
      link.click();

      // Clean up the link after download
      document.body.removeChild(link);

      console.log(response, "response");
      // fetchActionTaken()
    } catch (error) {
      // console.error("Error submitting order:", error);
      console.error("Error adding warranty:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Please add po expected date in item! Check on details page";
      await Swal.fire({
        title: "Message",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleSubmit = async () => {
    console.log("clicked");
    const payload = {
      expectedDate,
      remark: "",
      approvestatus: "Accept",
      poidarray: selectedRows,
    };

    try {
      const response = await axiosInstance.post(
        "purchaseorder/approverejectbulkPurchaseorder",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response, "response");
      //   toggleSerialDrawer();
      //   fetchPoStockout();
      fetchActionTaken();
      //   navigate(ROUTES_NAVIGATION.STOCKOUTDETAILS);
    } catch (error) {
      console.error("Error submitting approve:", error?.response?.data?.data);
      const errorMessage = error?.response?.data?.data;
      await showAlert({
        title: "Error",
        text: errorMessage || "An error occurred while uploading the file.",
        icon: "error",
      });
    }
  };

  // handle hold api calling
  const handleHold = async () => {
    console.log("clicked");

    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(
      2,
      "0"
    )}/${String(currentDate.getMonth() + 1).padStart(
      2,
      "0"
    )}/${currentDate.getFullYear()}`;
    const payload = {
      //   po_id: allotData?.po_id,
      remark: remark,
      approvestatus: "Hold",
      poidarray: selectedRows,
      expectedDate: formattedDate,
    };

    try {
      const response = await axiosInstance.post(
        "purchaseorder/approverejectbulkPurchaseorder",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response, "response");
      setIsHoldModalOpen(false);
      fetchActionTaken();
    } catch (error) {
      console.error("Error submitting order:", error);
      console.error("Error submitting approve:", error?.response?.data?.data);
      const errorMessage = error?.response?.data?.data;
      await showAlert({
        title: "Error",
        text: errorMessage || "An error occurred while uploading the file.",
        icon: "error",
      });
    }
  };

  const getCurrentDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0"); // January is 0!
    const yyyy = today.getFullYear();

    return `${dd}/${mm}/${yyyy}`;
  };

  const handleReject = async () => {
    const currentDate = getCurrentDate();
    console.log("clicked");
    const payload = {
      //   po_id: allotData?.po_id,
      remark: remark,
      approvestatus: "Reject",
      poidarray: selectedRows,
      expectedDate: currentDate,
    };

    try {
      const response = await axiosInstance.post(
        "purchaseorder/approverejectbulkPurchaseorder",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response, "response");
      setIsModalOpen(false);
      fetchActionTaken();
    } catch (error) {
      console.error("Error submitting order:", error);
      console.error("Error submitting approve:", error?.response?.data?.data);
      const errorMessage = error?.response?.data?.data;
      await showAlert({
        title: "Error",
        text: errorMessage || "An error occurred while uploading the file.",
        icon: "error",
      });
    }
  };

  const openRejectModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setRemark("");
  };

  const openHoldModal = () => {
    setIsHoldModalOpen(true);
  };

  const closeHoldModal = () => {
    setIsHoldModalOpen(false);
  };

  const handleAcceptModalOpen = () => {
    setAcceptModal(true);
  };

  const closeAcceptModal = () => {
    setAcceptModal(false);
  };

  const handleExportModalOpen = () => {
    setExportModal(true);
    setFormData({});
  };

  const handleExportModalClose = () => {
    setExportModal(false);
    setFormData({});
  };

  // const handledownload = async () => {
  //   try {
  //     const response = await axiosInstance.post(`/upload-purchaseOrder-details`, {

  //     },
  //        {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //       responseType: 'blob', // Set response type to blob for file downloads
  //     });

  //     // Create a URL for the file blob
  //     const url = window.URL.createObjectURL(new Blob([response.data]));

  //     // Create a link element
  //     const link = document.createElement('a');
  //     link.href = url;

  //     // Set the file name for the download to .csv
  //     link.setAttribute('download', 'sample.csv'); // Changed to .csv

  //     // Append the link to the body (required for some browsers)
  //     document.body.appendChild(link);

  //     // Programmatically trigger the click event on the link
  //     link.click();

  //     // Clean up the link after download
  //     document.body.removeChild(link);

  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const UploadInputs = [
    {
      name: "uploadDocument",
      label: " ",
      type: "uploadCsvOrderManagement",
      required: true,
      gridClass: "col-lg-6",
      //validation:{required:true}
    },
  ];

  //   const handleFormSubmit = async (formData) => {
  //     const result = await Swal.fire({
  //         title: "Confirmation",
  //         text: "Are you sure you want to this record?",
  //         icon: "warning",
  //         showCancelButton: true,
  //         confirmButtonText: "Yes",
  //         cancelButtonText: "No",
  //         showLoaderOnConfirm: true,
  //         preConfirm: async () => {
  //     try {
  //           const formDataToSend = new FormData();
  //           formDataToSend.append('bulkUpload', formData.uploadDocument);
  //           formDataToSend.append("loginUserId",loginUserId )
  //          // formDataToSend.append('accepted_qty', 3);

  //           console.log(formData, "uploadedDocument");

  //           const response = await axiosInstance.post(`/upload-purchaseOrder-details`, formDataToSend, {
  //             headers: {
  //               'Content-Type': 'multipart/form-data',
  //               Authorization: `Bearer ${token}`,
  //             },
  //           });

  //           console.log(response?.data?.data, "DAtavalues")

  //       const { errors, success } = response.data.data

  //       console.log(errors.length, "errors")
  //       setErrorVal(errors.length)

  //       // if (errors.length > 0) {
  //       //   setExportModal(false);
  //       //   setShowResultModal(true);
  //       // }

  //       if (errors.length > 0) {
  //         setExportModal(false);
  //         setShowResultModal(true);
  //       } else {

  //         await showAlert({
  //           title: "Success",
  //           text: "File Uploaded successfully.",
  //           icon: "success",
  //           confirmButtonText: "OK",
  //         });
  //         fetchActionTaken();
  //         setExportModal(false);
  //       }

  //       setSuccessVal(success.length)

  //     const failedRows = response.data.data.errors
  //     setFailedRows(failedRows)
  //     if(response.status === 200){
  //       // fetchActionTaken()
  //       // setFormData({})
  //     }
  //     } catch (error) {
  //     }
  // }

  // })
  // if (!result.isConfirmed) {
  //     // setLoading(false);
  //   }

  //   };
  // -------------------------------------------------
  // new handle form submit

  const handleFormSubmit = async (formData) => {
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const formDataToSend = new FormData();
          formDataToSend.append("bulkUpload", formData.uploadDocument);
          formDataToSend.append("loginUserId", loginUserId);

          const response = await axiosInstance.post(
            `/upload-purchaseOrder-details`,
            formDataToSend,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          const { errors, success } = response.data.data;
          setErrorVal(errors.length);
          setSuccessVal(success.length);
          setFailedRows(errors);

          if (errors.length > 0) {
            setExportModal(false); // Close the custom modal

            // Show SweetAlert modal with failed record info
            await showAlert({
              title: "Upload Unsuccessful",
              text: `File uploaded with ${success.length} successful rows and ${errors.length} failed rows.`,
              icon: "warning",
              confirmButtonText: "Export Failed Rows",
              showCancelButton: true,
              cancelButtonText: "Close",
            }).then((result) => {
              if (result.isConfirmed) {
                downloadFailedRowsCSV(formData.uploadDocument, errors); // Call your CSV download function
              }
            });
          } else {
            await showAlert({
              title: "Success",
              text: "File Uploaded successfully.",
              icon: "success",
              confirmButtonText: "OK",
            });
            fetchActionTaken();
            setExportModal(false);
          }
        } catch (error) {
          // const errorMessage =
          // await showAlert({
          //   title: "Error",
          //   text: "An error occurred while uploading the file.",
          //   icon: "error"
          // });
          console.error(
            "Error submitting uploadform:",
            error?.response?.data?.data
          );
          const errorMessage = error?.response?.data?.data;
          await showAlert({
            title: "Error",
            text: errorMessage || "An error occurred while uploading the file.",
            icon: "error",
          });
        }
      },
    });

    if (!result.isConfirmed) {
      // Optional: handle if user cancels the confirmation
    }
  };

  const readCSVFile = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const rows = data.split("\n").map((row) => row.split(","));
      setUploadedHeaders(rows[0]); // Save headers for downloading successful records
      callback(rows);
    };
    reader.readAsText(file); // Read as text for CSV
  };

  const downloadRowsCSV = (rows, headers, filename) => {
    if (!Array.isArray(rows) || !rows.every((row) => Array.isArray(row))) {
      console.error("Invalid data format for CSV download:", rows);
      return;
    }

    const finalData = [headers, ...rows];
    const csvContent = finalData.map((row) => row.join(",")).join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", filename); // Set the download file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadFailedRowsCSV = (uploadedFile, failedRows) => {
    readCSVFile(uploadedFile, (csvData) => {
      const headers = [...csvData[0], "ErrorMessage"];

      const failedRowsData = failedRows.map((errorRow) => {
        const originalRow = csvData[errorRow.lineNumber] || [];
        const errorMessage = errorRow.message || "Error";
        return [...originalRow, errorMessage];
      });
      downloadRowsCSV(failedRowsData, headers, "failed_records.csv"); // Trigger download
    });
  };

  const handleDateChange = (e) => {
    const value = e.target.value;
    const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

    // Check if input matches the dd/mm/yyyy format
    if (value === "" || dateRegex.test(value)) {
      setExpectedDate(value);
    }
  };

  // const formatDate = (date) => {
  //   if (!date) return '';
  //   const [year, month, day] = date.split('-');
  //   return `${day} ${month} ${year}`; // Format as dd mm yyyy
  // };

  return (
    <>
      <div className="stocktablecontainer">
        <div style={{ display: "flex", justifyContent: "end", gap: "10px" }}>
          {/* {isSubmit && (
          <div className=" mt-3">
            <button style={{padding:"10px 35px"}} className="submit-btn" onClick={handleSubmit}>
              Approve
            </button>
          </div>
        )}
        {isSubmit &&  (
          <div className=" mt-3">
            <button style={{paddingLeft:"40px", paddingRight:"40px"}} className="clear-btn" onClick={openRejectModal}>
              Reject
            </button>
          </div>
        )} */}

          {/* {isOrderPending && (
            <>
              <div className="mt-3">
                <button
                  style={{ padding: "10px 35px" }}
                  className="submit-btn"
                  onClick={handleAcceptModalOpen}
                >
                  Approve
                </button>
              </div>
              <div className="mt-3">
                <button
                  style={{ paddingLeft: "40px", paddingRight: "40px" }}
                  className="clear-btn"
                  onClick={openRejectModal}
                >
                  Reject
                </button>
              </div>
              <div className="mt-3">
                <button
                  style={{ padding: "10px 35px" }}
                  className="submit-btn"
                  onClick={openHoldModal}
                >
                  Hold
                </button>
              </div>
            </>
          )}

          {isModified && (
            <>
              <div className="mt-3">
                <button
                  style={{ padding: "10px 35px" }}
                  className="submit-btn"
                  onClick={handleAcceptModalOpen}
                >
                  Approve
                </button>
              </div>
            </>
          )}

          {reSubmitted && (
            <>
              <div className="mt-3">
                <button
                  style={{ padding: "10px 35px" }}
                  className="submit-btn"
                  onClick={handleAcceptModalOpen}
                >
                  Approve
                </button>
              </div>
            </>
          )} */}
{/* 
          {isHold && (
            <>
              <div className="mt-3">
                <button
                  style={{ padding: "10px 35px" }}
                  className="submit-btn"
                  onClick={handleAcceptModalOpen}
                >
                  Approve
                </button>
              </div>
              <div className="mt-3">
                <button
                  style={{ paddingLeft: "40px", paddingRight: "40px" }}
                  className="clear-btn"
                  onClick={openRejectModal}
                >
                  Reject
                </button>
              </div>
              <div className="mt-3">
                <button
                  style={{ padding: "10px 35px" }}
                  className="submit-btn"
                  onClick={openHoldModal}
                >
                  Hold
                </button>
              </div>
            </>
          )} */}

          {isOrderApproved || isOrderPartiallyApproved ? (
            <>
              <div className=" mt-3">
                <button
                  style={{ padding: "10px 35px" }}
                  className="submit-btn"
                  onClick={handleExportToExcel}
                >
                  Export to excel
                </button>
              </div>
              {/* <div className=" mt-3">
                <button
                  style={{ padding: "10px 35px" }}
                  className="submit-btn"
                  onClick={handleApprovedCancel}
                >
                  Cancel
                </button>
              </div>
              <div className="mt-3">
                <button
                  style={{ padding: "10px 35px" }}
                  className="submit-btn"
                  onClick={handleExportModalOpen}
                >
                  Upload
                </button>
              </div> */}
            </>
          ) : null}

          {/* {isExport && (
            <div className=" mt-3">
            <button style={{padding:"10px 35px"}} className="submit-btn" onClick={handleExport}>
              Export
            </button>
          </div>
          )
        } */}
        </div>

        {/* Hold Modal */}

        {isHoldModalOpen && (
          <div className="customModalOverlay">
            <div className="custom-modal">
              <div className="custom-modal-header">
                <h6 style={{ fontSize: "18px" }}>Remarks</h6>
                <button className="close-button" onClick={closeHoldModal}>
                  ×
                </button>
              </div>
              <div className="custom-modal-body">
                <textarea
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  placeholder="Add your remark here"
                  rows="4"
                  className="remark-textarea"
                />
              </div>
              <div className="custom-modal-footer">
                <button
                  className="btn btn-primary"
                  style={{
                    background: "#7BD755",
                    color: "white",
                    border: "none",
                    borderRadius: "20px",
                    padding: " 10px 28px",
                  }}
                  onClick={handleHold}
                >
                  Hold
                </button>
                <button
                  className="btn btn-primary"
                  style={{
                    background: "white",
                    color: "#7BD755",
                    border: "1px solid #7BD755",
                    borderRadius: "20px",
                    padding: " 10px 28px",
                  }}
                  onClick={closeHoldModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Reject Modal */}

        {isModalOpen && (
          <div className="customModalOverlay">
            <div className="custom-modal">
              <div className="custom-modal-header">
                <h6 style={{ fontSize: "18px" }}>Remarks</h6>
                <button className="close-button" onClick={closeModal}>
                  ×
                </button>
              </div>
              <div className="custom-modal-body">
                <textarea
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  placeholder="Add your remark here"
                  rows="4"
                  className="remark-textarea"
                />
              </div>
              <div className="custom-modal-footer">
                <button
                  className="btn btn-primary"
                  style={{
                    background: "#7BD755",
                    color: "white",
                    border: "none",
                    borderRadius: "20px",
                    padding: " 10px 28px",
                  }}
                  onClick={handleReject}
                >
                  Reject
                </button>
                <button
                  className="btn btn-primary"
                  style={{
                    background: "white",
                    color: "#7BD755",
                    border: "1px solid #7BD755",
                    borderRadius: "20px",
                    padding: " 10px 28px",
                  }}
                  onClick={closeModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Approve Modal */}

        {acceptModal && (
          <div className="customModalOverlay">
            <div className="custom-modal-expectedDate">
              <div className="custom-modal-header">
                <h6 style={{ fontSize: "18px" }}>Expected Delivery Date</h6>
                <button className="close-button" onClick={closeAcceptModal}>
                  ×
                </button>
              </div>
              <div className="custom-modal-body">
                <label
                  htmlFor="expectedDate"
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                  }}
                >
                  Expected Delivery Date
                </label>
                {/* <input
                          type="date"
                          id="expectedDate"
                          value={expectedDate} // Replace `remark` with a new `expectedDate` state
                          onChange={(e) => setExpectedDate(e.target.value)} // Ensure to create `setExpectedDate` for state management
                          // className="remark-textarea" 
                          style={{padding:"14px", borderRadius:"18px", border:"1px solid gray"}}
                        /> */}
                <div className="input-group">
                  <DatePicker
                    ref={(ref) =>
                      (datePickerRefs.current["expectedDate"] = ref)
                    }
                    placeholderText="DD/MM/YYYY"
                    selected={
                      expectedDate
                        ? new Date(expectedDate.split("/").reverse().join("-"))
                        : null
                    }
                    onChange={(date) => handleChange("expectedDate", date)}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    popperPlacement="bottom-start"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    minDate={new Date()}
                  />
                  <span
                    className="input-group-text"
                    onClick={() => openDatePicker("expectedDate")}
                    style={{ cursor: "pointer" }}
                  >
                    <FaCalendarAlt />
                  </span>
                </div>
              </div>
              <div className="custom-modal-footer">
                <button
                  className="btn btn-primary"
                  style={{
                    background: "#7BD755",
                    color: "white",
                    border: "none",
                    borderRadius: "20px",
                    padding: " 10px 28px",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </button>
                <button
                  className="btn btn-primary"
                  style={{
                    background: "white",
                    color: "#7BD755",
                    border: "1px solid #7BD755",
                    borderRadius: "20px",
                    padding: " 10px 28px",
                  }}
                  onClick={closeAcceptModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {exportModal && (
          <div className="customModalOverlay">
            <div className="custom-modal">
              <div className="custom-modal-header">
                <h6 style={{ fontSize: "18px" }}> Download and Upload </h6>
                <button
                  className="close-button"
                  onClick={handleExportModalClose}
                >
                  ×
                </button>
              </div>
              <div className="custom-modal-body">
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Export Date
                  </label>
                  <div>
                    <div className="input-group">
                      <DatePicker
                        ref={(ref) =>
                          (datePickerRefs.current["expectedDate"] = ref)
                        }
                        placeholderText="DD/MM/YYYY"
                        selected={
                          expectedDate
                            ? new Date(
                                expectedDate.split("/").reverse().join("-")
                              )
                            : null
                        }
                        onChange={(date) => handleChange("expectedDate", date)}
                        dateFormat="dd/MM/yyyy"
                        className="form-control"
                        popperPlacement="bottom-start"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                      />
                      <span
                        className="input-group-text"
                        onClick={() => openDatePicker("expectedDate")}
                        style={{ cursor: "pointer" }}
                      >
                        <FaCalendarAlt />
                      </span>
                    </div>
                  </div>
                </div>

                <label
                  htmlFor="expectedDate"
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    paddingTop: "20px",
                  }}
                >
                  Download
                </label>

                {/* <div style={{borderRadius:"30px", width:"250px"}} className='downloadiconwrapperr' onClick={handleExport}>
                        <a style={{fontSize:"15px", cursor:"pointer"}} className='downloadHeading'>Download</a>
                        <img src={downloadIcon} alt='download' className="downloadImg" />
                      </div> */}

                <div
                  style={{ borderRadius: "30px", width: "250px" }}
                  className="downloadiconwrapperr"
                >
                  <button
                    style={{
                      fontSize: "15px",
                      cursor: expectedDate ? "pointer" : "not-allowed",
                      backgroundColor: expectedDate ? "#fff" : "#fff",
                      color: expectedDate ? "#7BD755" : "gray",
                      border: "none",
                      borderRadius: "20px",
                      padding: "10px 20px",
                    }}
                    className="downloadHeading"
                    onClick={handleExport}
                    disabled={!expectedDate} // Disable if no date is selected
                  >
                    Download
                  </button>
                  <img
                    src={downloadIcon}
                    alt="download"
                    className="downloadImg"
                  />
                </div>

                <div>
                  <DynamicForm
                    formConfig={UploadInputs}
                    formData={formData}
                    setFormData={setFormData}
                    onSubmit={handleFormSubmit}
                    validationErrors={validationErrors}
                    setValidationErrors={setValidationErrors}
                  />
                </div>
              </div>
              <div className="custom-modal-footer">
                <button
                  className="btn btn-primary"
                  style={{
                    background: "#7BD755",
                    color: "white",
                    border: "none",
                    borderRadius: "20px",
                    padding: " 10px 28px",
                  }}
                  onClick={() => handleFormSubmit(formData)}
                >
                  Submit
                </button>
                <button
                  className="btn btn-primary"
                  style={{
                    background: "white",
                    color: "#7BD755",
                    border: "1px solid #7BD755",
                    borderRadius: "20px",
                    padding: " 10px 28px",
                  }}
                  onClick={handleExportModalClose}
                >
                  Cancel
                </button>
              </div>

              {/* {
                            successVal > 0 || errorVal > 0 ? (
                              <div style={{fontSize:"14px", textAlign:"center"}}>
                              File uploaded successfully with {successVal} successful rows and {errorVal} failed rows
                              </div>
                            ) : null
                        }
                        {errorVal  > 0 && (
                        <div className="result-wrapper">
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent:"center", paddingTop:"10px" }}>
                            <span style={{ color: 'red' }}>Failed Records: {errorVal}</span>
                            <img src={downloadIcon} alt='download' className="downloadImg" onClick={() => downloadFailedRowsCSV(formData.uploadDocument, failedRows)} style={{ cursor: 'pointer' }} />
                          </div>
                        </div>
                      )} */}
            </div>
          </div>
        )}

        {/* {showResultModal && (
  <div className="customModalOverlay">
    <div className="custom-modal">
      <div className="custom-modal-header">
        <h6 style={{ fontSize: "18px" }}>Upload Result</h6>
        <button className="close-button" onClick={() => setShowResultModal(false)}>×</button>
      </div>
      <div className="custom-modal-body">
      <div>
                      <DynamicForm
                      formConfig={UploadInputs}
                      formData={formData}
                      setFormData={setFormData}
                      onSubmit={handleFormSubmit}
                      validationErrors={validationErrors}
                      setValidationErrors={setValidationErrors}
                      />
                      </div>

                      </div>

                      <div className="custom-modal-footer">
                            <button
                                className="btn btn-primary"
                                style={{ background: "#7BD755", color: "white", border: "none", borderRadius:"20px", padding:" 10px 28px" }}
                                onClick={()=>handleFormSubmit(formData)}
                            >
                                Submit
                            </button>
                            <button className="btn btn-primary"  style={{ background: "white", color: "#7BD755", border: "1px solid #7BD755", borderRadius:"20px", padding:" 10px 28px" }} onClick={handleExportModalClose}>
                                Cancel
                            </button>
                        </div>
        {(successVal > 0 || errorVal > 0) && (
          <div style={{ fontSize: "14px", textAlign: "center" }}>
            File uploaded successfully with {successVal} successful rows and {errorVal} failed rows
          </div>
        )}
        {errorVal > 0 && (
          <div className="result-wrapper">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: "center", paddingTop: "10px" }}>
              <span style={{ color: 'red' }}>Failed Records: {errorVal}</span>
              <img
                src={downloadIcon}
                alt="download"
                className="downloadImg"
                onClick={() => downloadFailedRowsCSV(formData.uploadDocument, failedRows)}
                style={{ cursor: 'pointer' }}
              />
            </div>
          </div>
        )}
    </div>
  </div>
)} */}

        <table className="custom-table">
          <thead>
            <tr>
              {isSubmit && (
                <th>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                  />
                </th>
              )}
              {headers?.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sanitizedData?.map((row, rowIndex) => {
              console.log(row, "rowDataValue");
              const rowId = row.po_id;
              const totalPrice =
                row.purchase_price * (quantities[rowId] || 1) * 1.18;

              return (
                <tr key={rowId} onClick={() => handleClicableRow(row)}>
                  {isSubmit && (
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(rowId)}
                        onChange={() => handleRowSelect(rowId)}
                        onClick={(e) => e.stopPropagation()} // Prevent row click on checkbox click
                      />
                    </td>
                  )}
                  {headers?.map((header, colIndex) => {
                    const key = keyMapping[header];
                    // OrderClaimIcon
                    if (header === "Action") {
                      return (
                        <td key={colIndex}>
                          {key.map((action, actionIndex) => (
                            <img
                              key={actionIndex}
                              src={
                                // rowId === editRowId && action.type === "edit"
                                //   ? updateIcon
                                //   : action.icon

                                rowId === editRowId && action.type === "edit"
                                  ? updateIcon
                                  : action.type === "mailOrder" &&
                                    row.is_order_accepted === 3 &&
                                    row.erp_pdf_attched_file !== null
                                  ? action?.icon
                                  : action.type === "view"
                                  ? action?.icon
                                  : action.type === "OrderClaimIcon" &&
                                    (row.status ===
                                      "Partially Rejected By Dealer" || row.status === "Rejected By Dealer" || row.status === "Partially Accepted By Dealer" ||  row.status === "Dispatched" || row.status === "Partial Delivered")
                                  ? action?.icon
                                  : action.type === "acceptorderdetails" &&
                                    row.download_challan === 1
                                  ? action?.icon
                                  : null
                              }
                              style={{ gap: 5, marginLeft: 10 }}
                              data-tip={action.label}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (
                                  action.type === "edit" &&
                                  rowId !== editRowId
                                ) {
                                  handleEditClick(row); // Enter edit mode for this row
                                } else if (updateIcon) {
                                  handleSave(row); // Save changes for this row
                                } else if (action.type === "view") {
                                  handleViewButton(row);
                                } else if (action.type === "OrderClaimIcon") {
                                  handleOrderClaimIcon(row);
                                } else if (action.type === "mailOrder") {
                                  handleMailFunc(row);
                                } else if (
                                  action.type === "acceptorderdetails"
                                ) {
                                  pdfDownLoad(row);
                                }
                              }}
                              className="action-icon"
                            />
                          ))}
                        </td>
                      );
                    }

                    if (
                      header === "Order Quantity" &&
                      isSubmit &&
                      selectedRows.includes(rowId)
                    ) {
                      return (
                        <td key={colIndex}>
                          <input
                            type="number"
                            value={quantities[rowId] || ""}
                            onChange={(e) => handleQuantityChange(e, rowId)}
                            style={{
                              width: "56px",
                              height: "28px",
                              padding: "4px",
                              fontSize: "14px",
                              fontWeight: "500",
                              borderRadius: "4px",
                              border: "2px solid #7BD755",
                              paddingLeft: "10px",
                            }}
                          />
                        </td>
                      );
                    }

                    if (header === "Status") {
                      return (
                        <td key={colIndex} className="statusheader">
                          <span
                            className={
                              row[key] === "Approved" || row[key] === "Active"
                                ? "paymentstatus"
                                : row[key] === "Pending"
                                ? "inactive-status"
                                : row[key] === "Partial Approved"
                                ? "partial-approved"
                                : row[key] === "Modified"
                                ? "modified"
                                : row[key] === "Partial Delivered"
                                ? "partial-approved"
                                : row[key] === "Hold"
                                ? "holdstatus"
                                : row[key] === "View VIN"
                                ? "deliveredStatus"
                                : row[key] === "Inactive"
                                ? "rejected-Status"
                                : "rejected-Status"
                            }
                          >
                            {row[key]}
                          </span>
                        </td>
                      );
                    }

                    // if (header === "Status") {
                    //   return (
                    //     <td key={colIndex} className="statusheader">

                    //         <span
                    //           className={
                    //             row[key] === "Approved" || row[key] === "Active"
                    //               ? "paymentstatus"
                    //               : row[key] === "Pending"
                    //               ?  "inactive-status"
                    //                : row[key] === "Partial Approved"
                    //                ? "partial-approved"
                    //                 : row[key] === "Partial Delivered"
                    //                ? "partial-approved"
                    //                : row[key] === "Hold"
                    //                ? "holdstatus"
                    //                 : row[key] === "View VIN"
                    //                ? "deliveredStatus"
                    //               : row[key] === "Inactive"
                    //               ?  "rejected-Status"
                    //               : "rejected-Status"

                    //           }
                    //         >
                    //           {row[key]}
                    //         </span>

                    //     </td>
                    //   );
                    // }

                    if (header === "Total Price") {
                      return <td key={colIndex}>{totalPrice.toFixed(2)}</td>;
                    }

                    return <td key={colIndex}>{row[key]}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 20px",
            width: "100%",
          }}
        >
          <div className="totalDataCounts">
            {totalRecords > 0
              ? `Showing ${getStartIndex()} to ${getEndIndex()} of Total ${totalRecords} Records`
              : "No records found"}
          </div>
          <div className="pagination">
            <FaChevronLeft
              onClick={handlePreviousPage}
              className={
                currentPage === 0
                  ? "pagination-icon disabled"
                  : "pagination-icon"
              }
            />
            <div className="pagination-btns">
              {startPage > 0 && (
                <span
                  onClick={() => handlePageClick(0)}
                  className="pagination-btn"
                >
                  1
                </span>
              )}
              {startPage > 1 && <span className="pagination-btn">...</span>}
              {Array.from({ length: endPage - startPage + 1 }, (_, index) => (
                <span
                  key={startPage + index}
                  onClick={() => handlePageClick(startPage + index)}
                  className={
                    currentPage === startPage + index
                      ? "pagination-btn pagination-active"
                      : "pagination-btn"
                  }
                >
                  {startPage + index + 1}
                </span>
              ))}
              {endPage < totalPages - 2 && (
                <span className="pagination-btn">...</span>
              )}
              {endPage < totalPages - 1 && (
                <span
                  onClick={() => handlePageClick(totalPages - 1)}
                  className="pagination-btn"
                >
                  {totalPages}
                </span>
              )}
            </div>
            <FaChevronRight
              onClick={handleNextPage}
              className={
                currentPage === totalPages - 1
                  ? "pagination-icon disabled"
                  : "pagination-icon"
              }
            />
          </div>
        </div> */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 20px",
          width: "100%",
        }}
      >
        <div className="totalDataCounts">
          {totalRecords > 0
            ? `Showing ${getStartIndex()} to ${getEndIndex()} of Total ${totalRecords} Records`
            : "No records found"}
        </div>
        {totalRecords > 0 && ( // Conditionally render pagination if records are present
          <div className="pagination">
            <FaChevronLeft
              onClick={handlePreviousPage}
              className={
                currentPage === 0
                  ? "pagination-icon disabled"
                  : "pagination-icon"
              }
            />
            <div className="pagination-btns">
              {startPage > 0 && (
                <span
                  onClick={() => handlePageClick(0)}
                  className="pagination-btn"
                >
                  1
                </span>
              )}
              {startPage > 1 && <span className="pagination-btn">...</span>}
              {Array.from({ length: endPage - startPage + 1 }, (_, index) => (
                <span
                  key={startPage + index}
                  onClick={() => handlePageClick(startPage + index)}
                  className={
                    currentPage === startPage + index
                      ? "pagination-btn pagination-active"
                      : "pagination-btn"
                  }
                >
                  {startPage + index + 1}
                </span>
              ))}
              {endPage < totalPages - 2 && (
                <span className="pagination-btn">...</span>
              )}
              {endPage < totalPages - 1 && (
                <span
                  onClick={() => handlePageClick(totalPages - 1)}
                  className="pagination-btn"
                >
                  {totalPages}
                </span>
              )}
            </div>
            <FaChevronRight
              onClick={handleNextPage}
              className={
                currentPage === totalPages - 1
                  ? "pagination-icon disabled"
                  : "pagination-icon"
              }
            />
          </div>
        )}
      </div>
    </>
  );
};

DetailsTable.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  keyMapping: PropTypes.object.isRequired,
  handleEditClick: PropTypes.func.isRequired,
  handleQuantityChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  editRowId: PropTypes.number,
  editedQuantity: PropTypes.object.isRequired,
};

DetailsTable.defaultProps = {
  itemsPerPage: 10,
  isAllocation: false,
};

export default DetailsTable;
